export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/price-benefits.fc58c079.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};